export function requiredIf(type, condition) {
  return function (props, _propName, _componentName) {
    var test = condition(props) ? type.isRequired : type;
    return test.apply(this, arguments);
  };
}
